/**
 * LOS RANGOS DEL PERFIL, LOS MISMOS QUE EL SERVIDOR.
 *
 * Copia exacta de `RANGOS_PERFIL` (backend/models/user.py): los limites con los que la API
 * acepta o rechaza el peso, la altura, la edad y el % graso, y con los que `datos_dudosos`
 * decide si a este cliente le sale el aviso de «macros provisionales».
 *
 * POR QUE HACE FALTA AQUI (punto 46, 9-09). Es la misma historia de la fecha de nacimiento
 * (ver `fechaDeNacimiento.js`), con los otros cuatro campos. El cuestionario SIEMBRA lo que
 * ya hay en la ficha, da la pregunta por contestada y al terminar lo reenvia tal cual. Con
 * un valor viejo que el servidor no acepta -- los que entraron por la importacion de Calma,
 * directos a Mongo y sin pasar por la puerta de la API: alturas de 1 cm, pesos de 1 kg,
 * grasas del 71,8 % -- el cliente se estrella al guardar con un dato que no ha escrito el,
 * y no hay pantalla donde corregirlo.
 *
 * Asi que un valor imposible NO cuenta como contestado: se vuelve a preguntar.
 *
 * Los numeros viven aqui una sola vez para que la pantalla no diga una cosa y el servidor
 * otra, que es justo lo que paso con la altura (120-230 en las pantallas, 100-250 en el
 * perfil) hasta que se unificaron el 9-09.
 */
export const RANGOS_PERFIL = {
    weight: [25, 300],      // kg
    height: [120, 230],     // cm
    age: [14, 100],         // años
    body_fat: [3, 60],      // %
};

// Como se le nombra cada campo al cliente, y en que unidad. Es lo que se le lee en el
// aviso: «Tu altura, en centímetros. Entre 120 y 230.»
const COMO_SE_DICE = {
    weight: ['Tu peso', 'en kilos'],
    height: ['Tu altura', 'en centímetros'],
    age: ['Tu edad', 'en años'],
    body_fat: ['Tu porcentaje de grasa', 'en %'],
};

/** El número que hay escrito ahí, o `null` si eso no es un número. */
export function numeroDe(valor) {
    if (valor === null || valor === undefined || `${valor}`.trim() === '') return null;
    const n = parseFloat(String(valor).replace(',', '.'));
    return isNaN(n) ? null : n;
}

/**
 * ¿Vale ese valor para ese campo? Vacío es `false`: no hay nada que guardar.
 * Sin rango declarado (un campo que no es de estos cuatro) devuelve `true`: aquí no se
 * inventa un criterio que el servidor no tiene.
 */
export function datoDelPerfilUsable(campo, valor) {
    const rango = RANGOS_PERFIL[campo];
    if (!rango) return valor !== null && valor !== undefined && `${valor}`.trim() !== '';
    const n = numeroDe(valor);
    return n !== null && n >= rango[0] && n <= rango[1];
}

/**
 * Qué le pasa a ese valor, dicho para una persona. `null` si está bien o si está vacío
 * (que el campo esté en blanco lo dice el «te falta un campo», no un aviso de error).
 */
export function porQueNoValeElDato(campo, valor) {
    const rango = RANGOS_PERFIL[campo];
    if (!rango) return null;
    if (valor === null || valor === undefined || `${valor}`.trim() === '') return null;
    if (datoDelPerfilUsable(campo, valor)) return null;
    const [que, unidad] = COMO_SE_DICE[campo] || ['Ese dato', ''];
    return `${que}, ${unidad}. Entre ${rango[0]} y ${rango[1]}.`;
}

export default datoDelPerfilUsable;
